import { api } from './api';
import {
  CreateCustomerRequest,
  CreateCustomerResponse,
  DealerCheckboxResponse,
  DealerDetailsResponse,
  DealerSearchRequest,
  DealerSearchResponse,
  DeleteCustomerResponse,
  UpdateDealerRequest,
  UpdateDealerResponse,
} from './types';

export const customerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDealerBrands: builder.query<DealerCheckboxResponse, void>({
      query: () => ({
        url: `api/customer/brands`,
      }),
    }),

    getDealerShopTypes: builder.query<DealerCheckboxResponse, void>({
      query: () => ({
        url: `api/customer/shop-types`,
      }),
    }),

    getDealerList: builder.query<DealerSearchResponse, DealerSearchRequest>({
      query: (params) => ({
        url: `api/customer/search`,
        method: 'POST',
        body: params,
      }),
      providesTags: [{ type: 'Dealer', id: 'List' }],
    }),

    getDealerDetails: builder.query<DealerDetailsResponse, string>({
      query: (params) => ({
        url: `api/customer/details/?customerNo=${params}`,
      }),
      providesTags: [{ type: 'Dealer', id: 'Details' }],
    }),

    updateDealerDetails: builder.mutation<UpdateDealerResponse, UpdateDealerRequest>({
      query: (params) => ({
        url: `api/customer/actions/address/update`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: [{ type: 'Dealer', id: 'List' }],
    }),

    createCustomer: builder.query<CreateCustomerResponse, CreateCustomerRequest>({
      query: (params) => ({
        url: `api/customer/actions/user/create`,
        method: 'POST',
        body: params,
      }),
    }),

    deleteCustomer: builder.mutation<DeleteCustomerResponse, string>({
      query: (params) => ({
        url: `api/customer/actions/user/${params}/delete`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetDealerListQuery,
  useLazyGetDealerListQuery,
  useLazyGetDealerDetailsQuery,
  useGetDealerDetailsQuery,
  useUpdateDealerDetailsMutation,
  useLazyCreateCustomerQuery,
  useGetDealerBrandsQuery,
  useGetDealerShopTypesQuery,
  useDeleteCustomerMutation,
} = customerApi;
